export const customerStatuses={
    active:1,
    waitConfirmation:2,
    passive:3
}